/**
 * React Query hooks for Dashboard aggregation API.
 * IP-011: GET /api/dashboard/stats, GET /api/dashboard/activity
 */

import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "@/providers/api-provider";
import type { DashboardStats, AuditLogEntry } from "@/types";

export function useDashboardStats() {
  const api = useApiClient();

  return useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: () => api.get<DashboardStats>("/api/dashboard/stats"),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

export function useDashboardActivity(limit = 10, eventTypes?: string[]) {
  const api = useApiClient();

  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (eventTypes && eventTypes.length > 0) {
    params.set("eventTypes", eventTypes.join(","));
  }

  return useQuery({
    queryKey: ["dashboard", "activity", { limit, eventTypes }],
    queryFn: () =>
      api.get<{ items: AuditLogEntry[] }>(
        `/api/dashboard/activity?${params.toString()}`,
      ),
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
